import { useEffect, useState, useCallback } from 'react';
import { subscribe } from 'utils/FirebaseUtils';

/**
 * Hook to subscribe to Firestore updates
 * @param {Object} props - The props object
 * @param {string} props.path - The Firestore path to subscribe to
 * @returns {Object} The subscription state
 */
export function useFireStoreSubscription({ path }) {
  const [loading, setLoading] = useState(true);
  const [snapshot, setSnapshot] = useState(undefined);
  const [error, setError] = useState();

  const handleChange = useCallback((docSnapshot) => {
    setLoading(false);
    setSnapshot(docSnapshot);
    setError(null);
  }, []);

  const handleError = useCallback((error) => {
    if (error) {
      console.error(error);
      setError(error);
      setSnapshot(undefined);
      setLoading(false);
    } else {
      setError(null);
    }
  }, []);

  useEffect(() => {
    setLoading(true); // Reset loading state when path changes
    const unsubscribe = subscribe(path, {
      next: handleChange,
      error: handleError,
    });

    return () => {
      unsubscribe();
    };
  }, [path, handleChange, handleError]);

  return {
    loading,
    snapshot,
    error,
    isError: !!error,
  };
}
